<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Aluminium kozijnen</h1>

      <p>
        Aluminium kozijnen, die in de jaren ’50 voor het eerst werden toegepast,
        kunnen worden beschouwd als de vervangers van de traditionele stalen
        kozijnen. Vergelijken met deze stalen toepassing leverde de aluminium
        variant tal van voordelen op, waaronder het lagere gewicht en de langere
        levensduur. Bovendien hebben aluminium kozijnen een aanzienlijk hogere
        isolatiewaarde dan stalen kozijnen. Omdat het uiterlijk van een woning
        nauwelijks verandert wanneer stalen kozijnen vervangen worden door
        aluminium kozijnen, won aluminium in een snel tempo aan populariteit.
      </p>

      <p>
        Tegenwoordig zijn aluminium kozijnen nog steeds in trek, onder andere
        vanwege de volgende voordelen:
      </p>

      <ul>
        <li>Krachtig, solide lichtgewicht materiaal</li>
        <li>Inbraakwerend</li>
        <li>In nagenoeg alle kleuren verkrijgbaar</li>
        <li>Hoge isolatiewaarde</li>
        <li>Onderhoudsvriendelijk; aluminium is vuilafstotend</li>
        <li>Duurzaam</li>
        <li>Tal van mogelijkheden qua design</li>
        <li>Bij uitstek geschikt voor grote raamoppervlakken</li>
      </ul>

      <p>
        Zoals u ziet brengt aluminium legio voordelen met zich mee. Het is dan
        ook zaak om de aanschafprijs van aluminium kozijnen, die gemiddeld vrij
        hoog is en als nadeel kan worden beschouwd, in perspectief te zien: door
        bijvoorbeeld de lage onderhouds- en stookkosten bent u op de lange
        termijn wellicht zelfs goedkoper uit. Let er overigens in verband met de
        isolatiewaarde wel op dat er een zogenaamde thermische onderbreking is
        aangebracht, die condensatievorming beperkt. Aluminium kozijnen met een
        thermische onderbreking zijn te herkennen aan het VMRG-keurmerk, maar
        natuurlijk kunt u zich ook laten informeren door uw leverancier.
      </p>

      <h2>Aluminium kozijnen vergelijken?</h2>

      <p>
        Bent u overtuigd door de voordelen van aluminium kozijnen? Geef dan uw
        materiaalvoorkeur aan en ontdek bij welke regionale leverancier u
        terecht kunt voor de beste <nuxt-link to="/"> kozijnen </nuxt-link> van
        aluminium! Eerst meer lezen over
        <nuxt-link to="/informatie-over-kozijnen/kunststof">
          kunststof kozijnen
        </nuxt-link>
        en
        <nuxt-link to="/informatie-over-kozijnen/hout">
          houten kozijnen </nuxt-link
        >? Neem uw tijd en voorkom een haastige beslissing!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Aluminium kozijnen: de voor- en nadelen van aluminium!',
      headDescription:
        'Overweeg je om aluminium kozijnen aan te schaffen? Op Kozijnenvergelijker.nl lees je alles over aluminium kozijnen en vergelijk je gratis offertes!',
      path: '/informatie-over-kozijnen/aluminium',
    }
  },
}
</script>
